module.exports = __webpack_public_path__ + "static/media/crybanners.49e0c152.png";